<template>
  <ion-header>
  <ion-toolbar>
    <ion-item lines="none" class="header-row">
      <!-- unsichtbarer Spacer links, gleiche Breite wie das Close-Icon rechts -->
      <ion-icon
        class="ghost"
        slot="start"
        :ios="closeOutline"
        :md="closeOutline"
      />

      <ion-label class="title-wrap">
        {{ $t('privacyChanges') }}
      </ion-label>

      <!-- <ion-icon
        slot="end"
        :ios="closeOutline"
        :md="closeOutline"
        class="toolbar-close"
        @click="closeDialog()"
      />-->
    </ion-item>
  </ion-toolbar>
</ion-header>


  <ion-content class="ion-padding">
    <ion-card>
      <ion-card-header>
        <ion-card-title class="small-card-title">{{ $t('agb') }} / {{ $t('privacyPolicy') }}</ion-card-title>
      </ion-card-header>

      <ion-card-content>
        <!-- AGB: Header -->
        <ion-item button lines="full" detail="false" @click="showAgb = !showAgb">
          <ion-label>{{ $t('agb') }}</ion-label>
          <ion-icon
            slot="end"
            :ios="showAgb ? chevronUpOutline : chevronDownOutline"
            :md="showAgb ? chevronUpOutline : chevronDownOutline"
          />
        </ion-item>
        <!-- AGB: Body -->
        <div v-show="showAgb" class="section-body">
          <div class="content" v-text="agb"></div>
        </div>

        <!-- DSGVO: Header -->
        <ion-item class="ion-margin-top" button lines="full" detail="false" @click="showDsgvo = !showDsgvo">
          <ion-label>{{ $t('privacyPolicy') }}</ion-label>
          <ion-icon
            slot="end"
            :ios="showDsgvo ? chevronUpOutline : chevronDownOutline"
            :md="showDsgvo ? chevronUpOutline : chevronDownOutline"
          />
        </ion-item>
        <!-- DSGVO: Body -->
        <div v-show="showDsgvo" class="section-body">
          <div class="content" v-text="datalegal"></div>
        </div>
      </ion-card-content>
    </ion-card>

    <ion-item lines="none" class="ion-margin-top agree-item">
      <ion-checkbox v-model="checked" :aria-label="$t('iHaveReadAndAgree')" />
      <ion-label class="ion-margin-start ion-text-wrap">
        {{ $t('iHaveReadAndAgree') }}
      </ion-label>
    </ion-item>

    <div class="ion-margin-top ion-text-right">
      <ion-button fill="outline" @click="closeDialog()">{{ $t('cancel') }}</ion-button>
      <ion-button color="primary" :disabled="!checked || loading" @click="accept">
        {{ $t('acceptt') }}
      </ion-button>
    </div>
  </ion-content>
</template>

<script>
import {
  IonButton, IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonLabel, IonIcon,
  IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonCheckbox,
  modalController, toastController
} from '@ionic/vue'
import { defineComponent, ref } from 'vue'
import { closeOutline, chevronDownOutline, chevronUpOutline } from 'ionicons/icons'
import { useMutation } from '@vue/apollo-composable'
import acceptPrivacyMutation from '../../graphql/acceptPrivacy.mutation.gql'
import translate from '@/plugins/translate'

export default defineComponent({
  name: 'PrivacyDialog',
  components: {
    IonButton, IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonLabel, IonIcon,
    IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonCheckbox
  },
  props: {
    version:   { type: String, required: true },
    agb:       { type: String, required: true },
    datalegal: { type: String, required: true },
  },
  setup(props) {
    const checked   = ref(false)
    const showAgb   = ref(true)
    const showDsgvo = ref(true)

    const { mutate: acceptPrivacy, loading } = useMutation(acceptPrivacyMutation, {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    })

    const accept = async () => {
      try {
        const { data, errors } = await acceptPrivacy({ version: props.version })
        if (errors && errors.length) {
          ;(await toastController.create({
            message: translate('acceptError'),
            duration: 2000,
            color: 'danger'
          })).present()
          return
        }
        const ok = data?.acceptPrivacy === true
        if (ok) {
          ;(await toastController.create({
            message: translate('acceptSuccess'),
            duration: 2000,
            color: 'success'
          })).present()
          modalController.dismiss({ accepted: true })
        } else {
          ;(await toastController.create({
            message: translate('acceptRetry'),
            duration: 2000,
            color: 'warning'
          })).present()
        }
      } catch (e) {
        ;(await toastController.create({
          message: translate('acceptNetworkError'),
          duration: 2000,
          color: 'danger'
        })).present()
      }
    }

    const closeDialog = () => modalController.dismiss({ accepted: false })

    return {
      // icons
      closeOutline, chevronDownOutline, chevronUpOutline,
      // state/actions
      checked, showAgb, showDsgvo, accept, closeDialog, loading
    }
  }
})
</script>

<style scoped>
.content { white-space: pre-wrap; }
.section-body { padding: 8px 0; }

.header-row {
  --padding-start: 0;
  --inner-padding-end: 0;
  --min-height: 56px;
}

/* Linker „Ghost“-Spacer: reserviert Platz, aber unsichtbar */
.ghost {
  opacity: 0;
  pointer-events: none;
  font-size: 28px;  /* gleiche Größe wie rechts */
  padding: 8px;     /* gleiche Hit-Area */
}

/* Titel: zentriert & mehrzeilig */
.title-wrap {
  width: 100%;
  text-align: center;
  white-space: normal;   /* erlaubt Umbrüche */
  line-height: 1.2;
  font-weight: 600;
  font-size: 18px;       /* ggf. 17/16 testen */
  padding: 0 4px;        /* etwas Luft an den Rändern */
}

/* Close-Icon rechts */
.toolbar-close {
  font-size: 28px;
  padding: 8px;          /* größere Klickfläche */
  cursor: pointer;
}

/* Checkbox-Label darf umbrechen */
.agree-item ion-label {
  white-space: normal;    /* statt single-line/ellipsis */
  line-height: 1.25;
}

.small-card-title {
  font-size: 16px;   /* etwas kleiner als default */
  line-height: 1.25;
  white-space: normal; /* erlaubt Umbruch bei langen Texten */
}

</style>
